import React, { useEffect, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const testimonials = [{
  name: 'Sarah M.',
  location: 'Miami, FL',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=150&q=80',
  text: "I inherited a house that needed $40k in repairs. I didn't have the money or time. Bevo Coastal Investments made me a fair offer the next day and we closed in two weeks. So incredibly easy."
}, {
  name: 'David & Lisa T.',
  location: 'Tampa, FL',
  image: 'https://images.unsplash.com/photo-1559548331-f9cb98001426?auto=format&fit=crop&w=150&q=80',
  text: 'We wanted to downsize but dreaded the idea of staging our home and having strangers walk through it. Selling for cash was the best decision we made. Highly professional team.'
}, {
  name: 'Marcus J.',
  location: 'Orlando, FL',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150&q=80',
  text: 'Had a nightmare tenant situation and just wanted out. They bought the property with the tenant still in it. Saved me months of legal headaches and stress.'
}];
export function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setActiveIndex(current => (current + 1) % testimonials.length);
    }, 6000); // Increased to 6s
    return () => clearInterval(interval);
  }, [isPaused]);
  const handlePrev = () => {
    setActiveIndex(current => current === 0 ? testimonials.length - 1 : current - 1);
  };
  const handleNext = () => {
    setActiveIndex(current => (current + 1) % testimonials.length);
  };
  return <section className="py-20 md:py-28 px-6 md:px-12 lg:px-16" data-id="element-234">
      <div className="max-w-5xl mx-auto" data-id="element-235">
        <div className="text-center mb-16" data-id="element-236">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1B2A4A] mb-6 tracking-tight" data-id="element-237">
            Trusted by Homeowners Like You
          </h2>
        </div>

        <div className="relative" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-238">
          {/* Carousel Container */}
          <div className="overflow-hidden rounded-2xl shadow-sm bg-white border-l-4 border-[#E8913A] relative" data-id="element-239">
            {/* Fade masks for edges */}
            <div className="absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-240" />
            <div className="absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-241" />

            <div className="flex transition-transform duration-700 ease-in-out" style={{
            transform: `translateX(-${activeIndex * 100}%)`
          }} data-id="element-242">
              {testimonials.map(t => <div key={t.name} className="min-w-full p-8 md:p-16 flex flex-col justify-center relative" data-id="element-243">
                  {/* Decorative Quote Mark */}
                  <div className="absolute top-8 left-8 md:top-12 md:left-12 text-8xl font-serif text-[#E8913A]/10 leading-none select-none pointer-events-none" data-id="element-244">
                    "
                  </div>

                  <p className="text-2xl md:text-3xl text-[#1B2A4A] leading-relaxed font-light mb-10 text-center md:text-left relative z-10" data-id="element-245">
                    "{t.text}"
                  </p>
                  <div className="flex flex-col md:flex-row items-center justify-between gap-6 relative z-10" data-id="element-246">
                    <div className="flex items-center text-left" data-id="element-247">
                      <img src={t.image} alt={t.name} className="w-16 h-16 rounded-full object-cover mr-5 shadow-sm" data-id="element-248" />
                      <div data-id="element-249">
                        <h4 className="text-lg font-bold text-[#1B2A4A]" data-id="element-250">
                          {t.name}
                        </h4>
                        <p className="text-slate-500" data-id="element-251">{t.location}</p>
                      </div>
                    </div>
                    <div className="flex text-[#E8913A] text-sm tracking-widest" data-id="element-252">
                      ★★★★★
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Desktop Arrows */}
          <button onClick={handlePrev} className="hidden md:flex absolute top-1/2 -left-6 -translate-y-1/2 w-12 h-12 rounded-full bg-white shadow-md items-center justify-center text-[#1B2A4A] hover:bg-slate-50 hover:scale-105 transition-all z-20" aria-label="Previous testimonial" data-id="element-253">
            <ChevronLeftIcon className="w-6 h-6" data-id="element-254" />
          </button>
          <button onClick={handleNext} className="hidden md:flex absolute top-1/2 -right-6 -translate-y-1/2 w-12 h-12 rounded-full bg-white shadow-md items-center justify-center text-[#1B2A4A] hover:bg-slate-50 hover:scale-105 transition-all z-20" aria-label="Next testimonial" data-id="element-255">
            <ChevronRightIcon className="w-6 h-6" data-id="element-256" />
          </button>

          {/* Controls Container */}
          <div className="mt-8 max-w-[200px] mx-auto" data-id="element-257">
            {/* Dots Navigation */}
            <div className="flex justify-center items-center gap-3 mb-3" data-id="element-258">
              {testimonials.map((_, idx) => <button key={idx} onClick={() => setActiveIndex(idx)} className={`rounded-full transition-all duration-300 ${activeIndex === idx ? 'bg-[#E8913A] w-3 h-3' : 'bg-slate-300 w-2.5 h-2.5 hover:bg-slate-400'}`} aria-label={`Go to testimonial ${idx + 1}`} data-id="element-259" />)}
            </div>

            {/* Progress Bar */}
            {!isPaused && <div className="h-0.5 w-full bg-slate-200 rounded-full overflow-hidden" data-id="element-260">
                <div key={activeIndex} // Force re-render/re-animation on index change
            className="h-full bg-[#E8913A] animate-progress" data-id="element-261" />
              </div>}
          </div>
        </div>
      </div>
    </section>;
}